// use gsap splittext and scrolltrigger to animate text on scroll
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(SplitText, ScrollTrigger);

type SplitInstance = {
  trigger: ScrollTrigger;
  split?: SplitText;
};

const instances = new WeakMap<HTMLElement, SplitInstance>();
const tweens = new WeakMap<HTMLElement, gsap.core.Tween>();

const unwrapLineParents = (element: HTMLElement) => {
  const parents = element.querySelectorAll<HTMLElement>('.lineParent');
  parents.forEach((parent) => {
    const child = parent.firstChild;
    if (child) {
      parent.replaceWith(child);
    } else {
      parent.remove();
    }
  });
};

const setupElement = (element: HTMLElement) => {

  // element may container other block elements,
  // we want to animate each block element separately
  const blockElements = element.querySelectorAll<HTMLElement>(':scope > p,blockquote,div,h1,h2,h3,h4,h5,h6');
  if (blockElements.length > 0) {
    blockElements.forEach((child) => {
      child.classList.add('text-animation--slide-up-lines');
      setupElement(child);
    });
    element.classList.remove('text-animation--slide-up-lines');
    return;
  }

  if (element.dataset.animateSlideUpLinesDone === 'true') {
    return;
  }
  if (element.dataset.animationState === 'animating') {
    return;
  }

  const existing = instances.get(element);
  if (existing) {
    existing.trigger.kill();
    if (existing.split) {
      existing.split.revert();
      unwrapLineParents(element);
    }
  }
  const runningTween = tweens.get(element);
  if (runningTween) {
    runningTween.kill();
    tweens.delete(element);
  }

  let trigger: ScrollTrigger;
  trigger = ScrollTrigger.create({
    trigger: element,
    start: 'top bottom-=100px',
    once: true,
    onEnter: (self) => {
      // const staggerDelay = getStaggerDelay('global');
      element.dataset.animationState = 'animating';
      const activeTrigger = self;
      const split = new SplitText(element, { type: 'lines' });
      split.lines.forEach((line) => {
        line.classList.add('lineChild');
        const parent = document.createElement('span');
        parent.className = 'lineParent';
        line.parentNode?.insertBefore(parent, line);
        parent.appendChild(line);
      });
      const lineChildren = element.querySelectorAll<HTMLElement>('.lineChild');
      instances.set(element, { trigger: activeTrigger, split });
      const tween = gsap.from(lineChildren, {
        yPercent: 100,
        // delay: 0.25 + staggerDelay,
        duration: 0.75,
        ease: 'power4.out',
        stagger: 0.1,
        clearProps: 'transform',
        onComplete: () => {
          element.dataset.animationState = 'done';
          activeTrigger.kill();
          split.revert();
          // unwrapLineParents(element);
          element.dataset.animateSlideUpLinesDone = 'true';
          instances.delete(element);
          tweens.delete(element);
        }
      });
      tweens.set(element, tween);
    }
  });

  instances.set(element, { trigger });
};

const init = (elements: HTMLElement[]) => {
  elements.forEach((element) => setupElement(element));

};

export default {
  selector: '.text-animation--slide-up-lines',
  init
};
